import CallAPI from "@/functions/Cl_api";
import { DtoDocfilesGetResImple } from "mediadept-common/src/common/dto/DtoDocfilesGetResImple";
import { DtoDocfilesGetResRakurakuSyncImple } from "mediadept-common/src/common/dto/DtoDocfilesGetResRakurakuSyncImple";
import { Cl_docfile } from "./Cl_docfile";

export class Cl_docfileImple extends Cl_docfile {
  public static async getByClaimNumber(
    claimNumber: number
  ): Promise<DtoDocfilesGetResImple> {
    return Object.assign(
      new DtoDocfilesGetResImple(),
      await CallAPI.getRequest("/docfileclaims/" + claimNumber)
    );
  }
  public static async getSyncStatus(
    claimNumber: number
  ): Promise<DtoDocfilesGetResRakurakuSyncImple> {
    return Object.assign(
      new DtoDocfilesGetResImple(),
      await CallAPI.getRequest("/rakuraku-invoices/" + claimNumber)
    );
  }
  public static async syncRakuraku(
    claimNumber: number
  ): Promise<DtoDocfilesGetResImple> {
    return Object.assign(
      new DtoDocfilesGetResImple(),
      await CallAPI.postRequest("/rakuraku-invoices/" + claimNumber, null)
    );
  }
}
